import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxPagerComponent } from '../../shared/components/ngx-pager/ngx-pager.component';
import { PageResultCounterComponent } from '../../shared/components/ngx-pager/pageresult-counter/pageresult-counter.component';
import { SmartLabelPipe } from '../../shared/pipes/smartlabel.pipe';
import { EventSearchForm } from '../event-search-form/event-search.form';
import { EventSearchListRecordComponent } from '../event-search-list/event-search-list-record/event-search-list-record.component';
import { LoaderService } from '../../shared/services/loader.service';

@Component({
    selector: 'app-event-search-list',
    standalone: true,
    templateUrl: './event-search-list.component.html',
    providers: [EventSearchForm, DecimalPipe, Router],
    imports: [
        EventSearchListRecordComponent,
        CommonModule,
        NgxPagerComponent,
        PageResultCounterComponent,
        ReactiveFormsModule,
        SmartLabelPipe,
    ],
})
export class EventSearchListComponent implements OnInit {
    @Input({ required: true }) public eventSearchForm!: EventSearchForm;

    constructor(
        private readonly router: Router,
        public loaderService: LoaderService) {}

    async ngOnInit(): Promise<void> {
        this.eventSearchForm.search();
    }

    get showResultsLabel(): boolean {
        return this.eventSearchForm.totalCount > 0 && !this.eventSearchForm.isSearching;
    }

    get showNoAvailableResultsLabel(): boolean {
        return !this.eventSearchForm.recordsExist && !this.eventSearchForm.previousDaysPastEvent;
    }

    get showNoResultsFoundLabel(): boolean {
        return !this.eventSearchForm.recordsExist && this.eventSearchForm.previousDaysPastEvent;
    }

    exitEventList(eventId: number): void {
        if (!!this.eventSearchForm.controls['eventId'].value || this.eventSearchForm.controls['eventId'].value === 0) {
            sessionStorage.setItem('eventSearchEventId', this.eventSearchForm.controls['eventId'].value.toString());
        }
        if (!!this.eventSearchForm.controls['courseName'].value) {
            sessionStorage.setItem('eventSearchCourseName', this.eventSearchForm.controls['courseName'].value);
        }
        this.router.navigate([eventId, 'rosterView']);
    }
}
